//import styled from "styled-components";
import {ThemeButton} from "static/styled/custom.styled";

export const AssessmentThemeButton=ThemeButton.extend`
    width:200px;
`;
